import React, { useEffect, useState } from "react";
import bg1 from "../Assets/bg1.jpg";
import bg2 from "../Assets/bg2.jpg";
import bg3 from "../Assets/bg-3.jpg";
import { MdOutlineWest, MdOutlineEast } from "react-icons/md";
import { Link } from "react-router-dom";

const OurTeam = () => {
  const teamMembers = [
    {
      name: "John Loyd",
      role: "CEO",
      description:
        "OPC is a non-governmental organisation in Ghana that promotes social entrepreneurship in the field of regenerative food.",
      imgSrc: bg1, // Replace with the image URL for the first team member
    },
    {
      name: "Dave Lean",
      role: "Accountant",
      description:
        "OPC is a non-governmental organisation in Ghana that promotes social entrepreneurship in the field of regenerative food.",
      imgSrc: bg2, // Replace with the image URL for the first team member
    },
    {
      name: "Shawty King",
      role: "Marketer",
      description:
        "OPC is a non-governmental organisation in Ghana that promotes social entrepreneurship in the field of regenerative food.",
      imgSrc: bg3, // Replace with the image URL for the first team member
    },
    // Add other team members here in a similar object format
  ];

  const [activeIndex, setActiveIndex] = useState(
    Math.floor(teamMembers.length / 2)
  );

  const prev = () => {
    setActiveIndex(prevIndex =>
      prevIndex > 0 ? prevIndex - 1 : teamMembers.length - 1
    );
  };

  const next = () => {
    setActiveIndex(prevIndex =>
      prevIndex < teamMembers.length - 1 ? prevIndex + 1 : 0
    );
  };

  useEffect(
    () => {
      next();
    },
    2000,
    [activeIndex]
  );

  return (
    <div className='my-8 md:my-14 lg:my-20 lg:container mx-auto px-4'>
      <h1 className=' text-4xl text-right font-extrabold py-8'>
        <span className='border-b-4 border-b-green-600'>Our</span> Team
      </h1>
      <section className='py-6'>
        <div className='container flex flex-col items-center justify-center p-4 mx-auto space-y-8 sm:p-0'>
          {/* <h1 className='text-4xl font-bold leadi text-center sm:text-5xl'>
            Our team
          </h1> */}
          <p className='max-w-2xl text-center font-bold'>
            HERE AT OPC WE MAKE SURE WE HAVE THE BEST OF TEAMS TO PROVIDE THE
            BEST OF US IN WHAT WE DO
          </p>
          <div className='flex flex-row flex-wrap-reverse justify-center'>
            <div className='flex flex-col justify-center m-8 text-center'>
              <img
                alt=''
                className='self-center flex-shrink-0 w-24 h-24 mb-4 bg-center bg-cover rounded-full'
                src='https://source.unsplash.com/100x100/?portrait?0'
              />
              <p className='text-xl font-semibold leadi'>Leroy Jenkins</p>
              <p>Visual Designer</p>
            </div>
            <div className='flex flex-col justify-center m-8 text-center'>
              <img
                alt=''
                className='self-center flex-shrink-0 w-24 h-24 mb-4 bg-center bg-cover rounded-full'
                src='https://source.unsplash.com/100x100/?portrait?1'
              />
              <p className='text-xl font-semibold leadi'>Leroy Jenkins</p>
              <p>Visual Designer</p>
            </div>
            <div className='flex flex-col justify-center m-8 text-center'>
              <img
                alt=''
                className='self-center flex-shrink-0 w-24 h-24 mb-4 bg-center bg-cover rounded-full'
                src='https://source.unsplash.com/100x100/?portrait?2'
              />
              <p className='text-xl font-semibold leadi'>Leroy Jenkins</p>
              <p>Visual Designer</p>
            </div>
            <div className='flex flex-col justify-center m-8 text-center'>
              <img
                alt=''
                className='self-center flex-shrink-0 w-24 h-24 mb-4 bg-center bg-cover rounded-full'
                src='https://source.unsplash.com/100x100/?portrait?3'
              />
              <p className='text-xl font-semibold leadi'>Leroy Jenkins</p>
              <p>Visual Designer</p>
            </div>
            <div className='flex flex-col justify-center m-8 text-center'>
              <img
                alt=''
                className='self-center flex-shrink-0 w-24 h-24 mb-4 bg-center bg-cover rounded-full'
                src='https://source.unsplash.com/100x100/?portrait?4'
              />
              <p className='text-xl font-semibold leadi'>Leroy Jenkins</p>
              <p>Visual Designer</p>
            </div>
            <div className='flex flex-col justify-center m-8 text-center'>
              <img
                alt=''
                className='self-center flex-shrink-0 w-24 h-24 mb-4 bg-center bg-cover rounded-full'
                src='https://source.unsplash.com/100x100/?portrait?5'
              />
              <p className='text-xl font-semibold leadi'>Leroy Jenkins</p>
              <p>Visual Designer</p>
            </div>
          </div>
        </div>
      </section>

      <div className='mx-auto md:px-20 mt-4'>
        <Link
          to={`/team`}
          className='text-neutral-500 border-b-2 hover:text-green-500 hover:border-b-green-600 '
        >
          SEE MORE
        </Link>
      </div>
    </div>
  );
};

export default OurTeam;

//  <div className='relative'>
//    <div className='absolute bg-cyan-3 h-full w-full flex justify-between'>
//      <button
//        onClick={prev}
//        className='hidden md:block z-10  absolute transition duration-700 ease-in-out hover:scale-125 top-[50%] -translate-y-[50%] left-5 text-xl rounded-ful p-2bg-black/20 text-black cursor-pointer'
//      >
//        <MdOutlineWest size={30} />
//      </button>
//      <button
//        onClick={next}
//        className='hidden md:block z-10 bg-white absolute transition duration-700 ease-in-out hover:scale-125 top-[50%] -translate-y-[50%] right-5 text-xl rounded-ful p-2bg-black/20 text-black cursor-pointer'
//      >
//        <MdOutlineEast size={30} />
//      </button>
//    </div>

//    {/* slider container  */}
//    <div className='xl:w-[70rem] flex items-center justify-center md:px-20 overflow-x-hidden'>
//      {teamMembers.map((member, index) => (
//        <div
//          key={index}
//          className={`grid grid-cols-1 slg:grid-cols-2  slg:gap-8 max-w-5xl lg:mx-auto items-center lg:px-24 transition-all duration-500 translate-x-[0rem]  scont  ${
//            index === activeIndex ? " visible translate-x-[0rem]" : "hidden"
//          }`}
//        >
//          <div className=' h-[20rem] slg:h-[30rem] overflow-hidden'>
//            <img
//              src={member.imgSrc}
//              alt=''
//              className='h-[20rem] slg:h-[30rem] object-cover w-full scont-hover:scale-110 duration-700 ease-in-out transition-all '
//            />
//          </div>

//          <div className='flex flex-col'>
//            <div className='border-b-2 spacey-3 flex flex-col py-4 mb-6'>
//              <h1 className='text-2xl font-bold my-2'>
//                {member.name}{" "}
//                <span className='text-green-600'> - {member.role}</span>
//              </h1>
//              <h1 className='hidden md:block'>{member.description}</h1>
//              <h1 className='border-b-2 my-8 w-20 border-green-600'></h1>
//            </div>
//          </div>
//        </div>
//      ))}
//    </div>
//  </div>;
